import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import RH from '../../../components/rh/rh/listar/senha';


function EditRHSenhaScreen () {
    return (
        <Fragment>
            <Head titulo="Edição de Senha do RH | Consórcio LVF" />
            <Header />
            <RH />
            <Footer />
        </Fragment>
    );
}

export default EditRHSenhaScreen;